var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.757 50.237A32.295 32.295 0 0089.2 32.295H77.405a20.5 20.5 0 00-20.5-20.5V0a32.295 32.295 0 1026.852 50.237z",
    fill: "#6050DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.396 71.63L16.65 79.09l3.73-11.083 10.016 3.622z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 79.247a.157.157 0 01-.102-.037.157.157 0 01-.048-.172l3.73-11.083a.154.154 0 01.081-.091.157.157 0 01.123-.007l10.017 3.623a.16.16 0 01.021.29l-13.746 7.458a.157.157 0 01-.076.02zm3.828-11.036L16.93 78.757l13.08-7.099-9.532-3.447z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.56 44.959L.16 57.003l14.164 7.255 37.238-19.3z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.323 64.416a.155.155 0 01-.073-.018L.086 57.144a.158.158 0 01.036-.295l51.402-12.045a.159.159 0 01.108.296L14.396 64.398a.153.153 0 01-.073.018zM.616 57.059l13.706 7.02 36.034-18.676L.616 57.06z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.38 68.007L51.56 44.96 37.856 79.835 20.38 68.007z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.855 79.994a.155.155 0 01-.089-.027L20.29 68.138a.158.158 0 01-.005-.259l31.18-23.048a.158.158 0 01.192.002.159.159 0 01.052.184L38.002 79.893a.161.161 0 01-.101.094.17.17 0 01-.047.007zM20.654 68.001L37.78 79.592l13.43-34.177L20.654 68z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 79.09l-2.327-14.832 37.238-19.3L20.38 68.008l-3.73 11.082z",
    fill: "#F1F2F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.594 79.754L14.148 64.17l.102-.052 37.238-19.298.167.269-31.14 23.016-3.921 11.65zm-2.096-15.408l2.209 14.078 3.538-10.516L49.86 46.02 14.498 64.346z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 68.293l-.703 2.017 4.096 4.677 3.577-1.957-6.97-4.737z",
    fill: "#F1F2F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.44 44.684l-.14-.284c.124-.06 12.523-6.152 24.5-12.893 7.03-3.957 12.542-7.362 16.38-10.116 3.257-2.34 7.019-5.463 6.442-7.067-.555-1.544-5.454-2.372-25.64 2.449l-.074-.31c16.62-3.969 25.13-4.704 26.013-2.247.524 1.457-1.621 3.888-6.557 7.432-3.848 2.763-9.368 6.172-16.41 10.137-11.984 6.744-24.39 12.839-24.514 12.9z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.c6c80620.svg";
export { ForwardRef as ReactComponent };